var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('kst-input',{attrs:{"load-on-focus":"","field":"CategoryID","data":_vm.userData,"catalog":_vm.Catalog,"options":_vm.categoryOptions}}),_c('kst-input',{attrs:{"field":"Name","data":_vm.userData,"catalog":_vm.Catalog}}),_c('kst-input',{attrs:{"field":"IsActive","data":_vm.userData,"catalog":_vm.Catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }